import { render, staticRenderFns } from "./presentationWebcast.vue?vue&type=template&id=3f8cc248&scoped=true"
import script from "./presentationWebcast.vue?vue&type=script&lang=js"
export * from "./presentationWebcast.vue?vue&type=script&lang=js"
import style0 from "./presentationWebcast.vue?vue&type=style&index=0&id=3f8cc248&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8cc248",
  null
  
)

export default component.exports